export const selectPath = <T extends string>(record: Record<T, string>, type: T): string =>
  record[type] || 'undefinedUrl';
